module.exports = __webpack_public_path__ + "static/pic10-fc2217a3259dbe4bf90380771114f39c.jpg";